import { ArrowBackIosOutlined } from '@material-ui/icons';
import DehazeOutlinedIcon from '@material-ui/icons/DehazeOutlined';
import { makeStyles } from '@material-ui/styles';
import { ReactComponent as LongArrowRight } from 'assets/svg/longArrowRight.svg';
import { colorPrimary } from 'constants/themes';
import React, { HTMLProps, ReactElement, SetStateAction } from 'react';
import { NavLink } from 'react-router-dom';
import { PATH } from 'routes/constant';
import themes from 'styles/themes';
import logo from '../../assets/img/logo_black.png';
const useStyles = makeStyles({
    header: {
        position: 'absolute',
        top: 0,
        width: '100%',
        left: 0,
        right: 0,
        padding: '0 28px',
        height: '48px',
        minHeight: 48,
        zIndex: 1,
    },
    headerWrap: {
        flex: 1,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative',
    },
    title: {
        fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
        fontSize: 24,
        fontWeight: 400,
        textAlign: 'center',
        color: themes.palette.primary.main,
        margin: '0 auto',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    logo: {
        margin: '0 auto',
        width: '69px',
    },
    leftBtn: {
        left: 0,
        position: 'absolute',
    },
    rightBtn: {
        right: 0,
        position: 'absolute',
    },
});

interface ICustomHeaderProps extends HTMLProps<HTMLDivElement> {
    title?: string;
    showBackBtn?: boolean;
    showNextBtn?: boolean;
    showSideBarBtn?: boolean;
    showUserIcon?: boolean;
    backTo?: string;
    setIsOpen: React.Dispatch<SetStateAction<boolean>>;
    headerLeftBtn?: ReactElement;
    colorHeader?: String;
    isStylist?: boolean;
}

const CustomHeader = (props: ICustomHeaderProps) => {
    const classes = useStyles();
    return (
        <div className={classes.header} id="custom-header" style={{ ...props.style }}>
            <div className={classes.headerWrap}>
                <div className={classes.leftBtn}>
                    <React.Fragment>
                        {props.showSideBarBtn && (
                            <span
                                style={{
                                    color: `${themes.palette.primary.main}`,
                                    cursor: 'pointer',
                                }}
                                onClick={() => props.setIsOpen(true)}
                            >
                                <DehazeOutlinedIcon />
                            </span>
                        )}
                        {props.showBackBtn && (
                            <NavLink to={`${props.backTo || PATH.HOME}`}>
                                <ArrowBackIosOutlined
                                    style={{ color: themes.palette.primary.main, cursor: 'pointer' }}
                                />
                            </NavLink>
                        )}
                    </React.Fragment>
                </div>
                {props.title ? (
                    <p
                        className={classes.title}
                        style={{
                            color: `${props.colorHeader && colorPrimary}`,
                            fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
                        }}
                    >
                        {props.title}
                    </p>
                ) : (
                    <img src={logo} className={classes.logo} alt="logo" />
                )}
                <div className={classes.rightBtn}>
                    {props.showNextBtn && (
                        <>
                            <span
                                style={{
                                    marginRight: '10px',
                                    fontFamily: 'PoppinsRegular',
                                    fontWeight: 400,
                                    color: '#fff',
                                }}
                            >
                                Next
                            </span>
                            <LongArrowRight />
                        </>
                    )}
                    {props.headerLeftBtn && <>{props.headerLeftBtn}</>}
                </div>
            </div>
        </div>
    );
};

export default CustomHeader;
